/** Header surface and spacing; sticky and absolute positioning remain caller-controlled. */
function navbar(theme, { absolute, light }) {
  return {
    boxShadow: "none",
    backgroundColor: theme.palette.surface.main,
    color: light ? theme.palette.white.main : theme.palette.dark.main,
    top: 0,
    minHeight: { xs: 65, md: 74 },
    display: "grid",
    alignItems: "center",
    borderRadius: 0,
    borderBottom: "1px solid " + theme.palette.grey[300],
    marginBottom: { xs: 3.125, md: 3.75 },
    marginLeft: { xs: -2, md: -4.25 },
    marginRight: { xs: -2, md: -4.25 },
    width: "auto",
    padding: { xs: "0 16px", md: "0 34px" },
    ...(absolute && { left: 0, right: 0, marginLeft: 0, marginRight: 0 }),
    "& .MuiToolbar-root": { minHeight: "auto", padding: 0, gap: 2 },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  pt: 0.5,
  pb: 0.5,

  [breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0",
    paddingBottom: "0",
  },
});

const navbarRow = ({ breakpoints }, { isMini }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "auto",
  minWidth: 0,
  gap: 2,

  [breakpoints.up("md")]: {
    justifyContent: isMini ? "space-between" : "stretch",
    width: isMini ? "100%" : "max-content",
  },

  [breakpoints.up("xl")]: {
    justifyContent: "stretch !important",
    width: "max-content !important",
  },
});

const navbarIconButton = ({ typography: { size }, breakpoints }) => ({
  width: 40,
  height: 40,
  px: 0.75,
  "&:hover": { backgroundColor: "#eeeee9" },

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.md} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

const navbarMobileMenu = ({ breakpoints }) => ({
  display: "inline-block",
  lineHeight: 0,

  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu };
